module.exports = __webpack_public_path__ + "img/icon-home.aefd58f1.svg";